import { Component, Input } from '@angular/core';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TicketService } from 'src/app/private/services/tickets.service';
import { MessageService } from 'primeng/api';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TicketMiddleViewComponent } from "../ticket-middle-view/ticket-middle-view.component";

@Component({
  selector: 'app-ticket-card-view',
  imports: [SharedModule, InfiniteScrollModule, TicketMiddleViewComponent],
  templateUrl: './ticket-card-view.component.html',
  styleUrl: './ticket-card-view.component.scss'
})
export class TicketCardViewComponent {
  @Input() dataSource: any[] = [];
  @Input() loading: boolean = false;
  searchText: string = '';

  cardActiveIndex: number = 0;

  selectedTicket: any = null;

  constructor(
    private api: TicketService,
    private messageService: MessageService,
    private localStorage: LocalStorageService
  ) {
  }

  // tickets = [
  //   {
  //     initials: 'CC',
  //     name: 'Chetan Chumble',
  //     time: '5 min ago',
  //     message: 'Hi, I need help to process the payment for my order #12345. Can you assist me with this?  what is the status of my order? how can I track it? and when will it be delivered?',
  //     status: 'Open',
  //     priority: 'High priority',
  //   },
  //   {
  //     initials: 'GR',
  //     name: 'Gaurav Rathore',
  //     time: '7 min ago',
  //     message: 'Hi, I need help to process the payment for my order #12345. Can you assist me with this?  what is the status of my order? how can I track it? and when will it be delivered?',
  //     status: 'New',
  //     priority: 'Medium priority',
  //   },
  //   {
  //     initials: 'CC',
  //     name: 'Chetan Chumble',
  //     time: '10 min ago',
  //     message: 'Hi, I need help to process the payment for my order #12345. Can you assist me with this?  what is the status of my order? how can I track it? and when will it be delivered?',
  //     status: 'Open',
  //     priority: 'High priority',
  //   },
  //   {
  //     initials: 'AS',
  //     name: 'Aarsh Srivastava',
  //     time: '15 min ago',
  //     message: 'Hi, I need help to process the payment for my order #12345. Can you assist me with this?  what is the status of my order? how can I track it? and when will it be delivered?',
  //     status: 'New',
  //     priority: 'Low priority',
  //   },
  //   {
  //     initials: 'AS',
  //     name: 'Aarsh Srivastava',
  //     time: '15 min ago',
  //     message: 'Hi, I need help to process the payment for my order #12345. Can you assist me with this?  what is the status of my order? how can I track it? and when will it be delivered?',
  //     status: 'New',
  //     priority: 'Low priority',
  //   },
  // ];


  tickets: any[] = [];
  page = 0;
  isLoading = false;
  hasMore = true;

  ngOnInit() {
    this.loadTickets();
  }

  loadMore() {
    console.log("Load more tickets called");
    if (this.isLoading || !this.hasMore) return;
    this.page++;
    this.loadTickets();
  }

  loadTickets() {
    console.log("Loading tickets for page:", this.page);
    this.isLoading = true;
    const payload = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
      },

      "page": this.page * 5,
      "limit": 5,
      "order": {
        "col": "\"ticket\".\"updatedAt\"",
        "dir": "DESC"
      }
    };
    this.api.getAllTickets(payload).subscribe({
      next: (res) => {
        if (res?.rows?.length === 0) {
          this.hasMore = false;
        } else {

          let newTickets = res?.rows.map((ticket: any) => ({
            initials: ticket.assignedUser?.fname ? ticket.assignedUser?.fname?.charAt(0).toUpperCase() : 'N/A',
            name: ticket.assignedUser
              ? `${ticket.assignedUser.fname || ''} ${ticket.assignedUser.lname || ''}`.trim() || 'Unknown'
              : 'Not Assigned',
            time: new Date(ticket.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
            message: ticket.ticket_desc
              ? `${ticket.title} || ${ticket.ticket_desc}`
              : ticket.title || 'No description provided',
            status: ticket.ticket_status || 'New',
            priority: ticket.priority || 'Low priority',
            timeAgo: new Date(ticket.createdAt).toLocaleDateString() + ' | ' + new Date(ticket.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),

            id: ticket.id,
            title: ticket.title,
            ticket_id: ticket.ticket_id,
            created_by: ticket.created_by,
            updated_by: ticket.updated_by,
            attachments: ticket.attachments || [],
            source: ticket.source || 'Unknown',
            organization_id: ticket.organization_id,
            campus_id: ticket.campus_id,
            lead_id: ticket.lead_id || null,
            assign_to: ticket.assign_to || null,
            live_chat_data: ticket.live_chat_data || {},
            ticket_desc: ticket.ticket_desc || '',
            createdAt: ticket.createdAt,
            updatedAt: ticket.updatedAt,

          }));
          this.tickets = [...this.tickets, ...newTickets];

        }
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }




  getPriorityColor(priority: string): string {
    switch (priority) {
      case 'High':
        return '#D74843';
      case 'Medium':
        return '#F19A18';
      case 'Low':
        return '#0AA825';
      default:
        return '';
    }
  }

  getPriorityBackgroundColor(priority: string): string {
    switch (priority) {
      case 'High':
        return '#FFD0CE';
      case 'Medium':
        return '#FFEBCC';
      case 'Low':
        return '#D2FFD9';
      default:
        return '';
    }
  }

  getStatusColor(status: string): string {
    switch (status) {
      case 'Open':
        return '#0AA825';
      case 'New':
        return '#0960BD';
      default:
        return '';
    }
  }

  getStatusBackgroundColor(status: string): string {
    switch (status) {
      case 'Open':
        return '#D2FFD9';
      case 'New':
        return '#CFE6FF';
      default:
        return '';
    }
  }
}
